import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  GoogleAuthProvider,
  setPersistence,
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const firebaseConfig = {
  projectId: "aion-andoventures",
  appId: "1:726032204602:web:8d3b448f075ec2d6e94603",
  storageBucket: "aion-andoventures.firebasestorage.app",
  apiKey: "AIzaSyDEH-nkymka7RJYcUoiz0sSzS7GuMny2QM",
  authDomain: "aion-andoventures.firebaseapp.com",
  messagingSenderId: "726032204602",
  measurementId: "G-84SKVFKXC1",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west1");
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  login_hint: "andresmd01@gmail.com",
  prompt: "select_account",
});

void setPersistence(auth, browserLocalPersistence);

if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
